import React, {useState, useEffect} from 'react';
import Checkbox from '../../../components/Checkbox';

const AttendancesListItem = ({
        lecture, 
        booking,
        bookingIds,
        setBookingIds,
        borderBottom
    }) => {
    const [isInAttendance, setIsInAttendance] = useState();

    useEffect(() => {
        checkAttendance();
    }, []);


    function checkAttendance() {
        lecture.attendances.forEach((attendance) => {
            if (attendance.bookingId === booking.id) {
                setIsInAttendance(true)
                setBookingIds((bookingIds) => [...bookingIds, booking.id]); 
            }
        })
    }

    function setAttendance(isChecked) {
        if (isChecked) {
            setBookingIds([...bookingIds, booking.id]);
        }
        else {
            setBookingIds(bookingIds.filter((id) => id !== booking.id));
        }
    }

    return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            borderBottom: borderBottom ? "1px solid lightgrey" : "none"
          }}
          key={booking.coaEmpId}
        >
          <div style={{ flex: "0 0 40%" }}>
            {booking.coaEmpName}
          </div>
          <div style={{ flex: "0 0 30%" }}>
          </div>
          <div style={{ flex: "0 0 30%", textAlign: "right" }}>
             <Checkbox
                defaultChecked={isInAttendance}
                setValue={setAttendance}
            />
          </div>
        </div>
      );

}

export default function AttendancesList({lecture, bookingIds, setBookingIds}) {
    return (
        <div style={{
            margin: "6px 0px",
            maxHeight: "278px",
            minHeight: "260px",
            overflowY: "scroll"
          }}>
            {lecture.course.bookings.map((booking, index) => (
                <AttendancesListItem 
                    key={index}
                    lecture={lecture} 
                    booking={booking}
                    bookingIds={bookingIds}
                    setBookingIds={setBookingIds}
                    borderBottom={(lecture.course.bookings.length - 1) !== index}
                />  
            ))}
        </div>
    )
}

